class DillerConfigController extends AbstractIntegrationController
	@register()
	@inject '$scope',
		'Shops'
		'IntegrationConfiguration'

	integrationId: 'diller'

	initialize: ->
		@configuration = @IntegrationConfiguration.data if not _.isEmpty(@IntegrationConfiguration.data)
		@configuration.department_details ?= []
		@allShops = if not _.isEmpty(@Shops.data) then angular.copy(@Shops.data) else []
		@shops = angular.copy(@allShops)
		@shopSelection =
			shop_id: ''
			department_id: ''

		for department, i in @configuration.department_details
			shop = _.find(@allShops, {id: department?.shop_id})

			if shop?
				shop.is_selected = true
				department.shop_name = shop.name
			else
				@configuration.department_details.splice(i, 1)

		@updateShopsSelection()

	save: ->
		super(@configuration).then (response) =>
			@configuration = response.data

	addSelectedShop: ->
		shop = _.find(@allShops, {id: @shopSelection.shop_id})
		shop.department_id = @shopSelection.department_id
		shop.is_selected = true

		@configuration.department_details.push {
			shop_id: shop.id
			shop_name: shop.name
			department_id: shop.department_id
		}

		@updateShopsSelection()

		@newShopForm.$setPristine()
		@newShopForm.$setUntouched()
		@mainForm.$setDirty()

	setSelectedShopDepartmentId: ->
		@shopSelection.department_id = ''

		shop = _.find(@allShops, {id: @shopSelection.shop_id})

		if shop?.department_id
			@shopSelection.department_id = shop.department_id

	removeSelectedShop: (selectedShop) ->
		shop = _.find(@allShops, {id: selectedShop.shop_id})
		shop.is_selected = false
		@configuration.department_details = _.reject(@configuration.department_details, {shop_id: selectedShop.shop_id})

		@updateShopsSelection()
		@mainForm.$setDirty()

	updateShopsSelection: ->
		@shops = _.reject(@allShops, {is_selected: true})

		@shopSelection.shop_id = ''
		@shopSelection.department_id = ''

	afterDisconnect: ->
		@configuration =
			is_active: false
